(function () {
	'use strict';

	angular
		.module('app')
		.directive('modalOrchestrator', modalOrchestrator);

	modalOrchestrator.$inject = ['$window', 'jquery'];

	function modalOrchestrator($window, $) {
		// Usage:
		//     <modalOrchestrator></modalOrchestrator>
		// Creates:
		// 
		var directive = {
			controller: ['$scope', '$element', '$attrs', controller],
			restrict: 'EA'
		};
		return directive;

		function controller($scope, $element, $attrs) {
			let $ctrl = this;
			let modalClosingHandlers = [];

			var onModalClosingCatchAll = function () {
				$(".modal").on('hidden.bs.modal', function () {
					modalClosingHandlers.forEach(function (handler) {
						handler();
					});
				});
			}

			$ctrl.onModalsClosing = function (handler, modalId) {
				modalClosingHandlers.push(handler);
			}

			$ctrl.closeModals = function () {
				onModalClosingCatchAll();

				$(".modal").modal("hide");
			}

			onModalClosingCatchAll();
		}
	}

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_modalOrchestrator.js
// module id = 12
// module chunks = 0